import { Component } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import { newWebsite } from './new-website'

@Component({
  selector: 'dhp-new-website',
  templateUrl: './new-website.component.html',
  styleUrls: ['./new-website.component.scss'],
  imports: [TranslatePipe],
})
export class NewWebsiteComponent {
  protected readonly content = newWebsite
}
